/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	contact: require("./contact"),
};
